import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Organicé toda mi estructura de costos en un fin de semana. Ahora sé exactamente cuánto cobrar por metro cuadrado de pintura o revestimiento apenas piso la obra. Nunca más volví a perder una remodelación por tardar días en enviar un presupuesto.',
  author: 'Tomás M.',
  location: 'Buenos Aires',
  role: 'Arquitecto Independiente'
}, {
  quote: 'Las cláusulas del Escudo Comercial cambiaron todo. Logré cerrar una reforma integral en la primera visita y blindé mi dinero contra los típicos cambios de opinión del cliente a mitad de obra. Chau dolores de cabeza.',
  author: 'Ignacio R.',
  location: 'Rosario',
  role: 'Contratista de Obras Civiles'
}, {
  quote: 'Adapto el presupuesto final según los acabados del cliente en 5 minutos frente a él. Antes me llevaba horas buscar listas de precios viejas y armar un Excel coherente por las noches. Recuperé mi vida familiar.',
  author: 'Valentina F.',
  location: 'Córdoba',
  role: 'Diseñadora de Interiores'
}];
export function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollRef = useRef<HTMLDivElement>(null);
  const handleScroll = () => {
    if (scrollRef.current) {
      const scrollPosition = scrollRef.current.scrollLeft;
      const cardWidth = scrollRef.current.offsetWidth * 0.85; // approx width of card
      const newIndex = Math.round(scrollPosition / cardWidth);
      setActiveIndex(newIndex);
    }
  };
  const scrollTo = (index: number) => {
    if (scrollRef.current) {
      const cardWidth = scrollRef.current.offsetWidth * 0.85;
      scrollRef.current.scrollTo({
        left: index * cardWidth,
        behavior: 'smooth'
      });
      setActiveIndex(index);
    }
  };
  return <section className="py-10 sm:py-16 lg:py-24 bg-sky-50 overflow-hidden" data-id="element-231">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-232">
        {/* Mobile Carousel */}
        <div className="md:hidden" data-id="element-233">
          <div ref={scrollRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory hide-scrollbar pb-6 -mx-4 px-4 gap-4" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-234">
            {testimonials.map((t, index) => <div key={index} className="min-w-[85%] snap-center bg-white rounded-2xl p-6 shadow-sm border border-gray-100 relative flex flex-col" data-id="element-235">
                <Quote className="absolute top-4 right-4 w-6 h-6 text-brand-accent/20" data-id="element-236" />
                <div className="flex gap-1 mb-3" data-id="element-237">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-brand-accent fill-brand-accent" data-id="element-238" />)}
                </div>
                <p className="text-gray-700 italic mb-4 text-sm leading-relaxed relative z-10 flex-grow" data-id="element-239">
                  "{t.quote}"
                </p>
                <div className="mt-auto" data-id="element-240">
                  <p className="font-bold text-brand-dark text-sm" data-id="element-241">
                    {t.author}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-242">
                    {t.location} — {t.role}
                  </p>
                </div>
              </div>)}
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-2" data-id="element-243">
            {testimonials.map((_, index) => <button key={index} onClick={() => scrollTo(index)} className={`w-2 h-2 rounded-full transition-colors ${activeIndex === index ? 'bg-brand-accent' : 'bg-gray-300'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-244" />)}
          </div>
        </div>

        {/* Desktop Grid */}
        <div className="hidden md:grid grid-cols-3 gap-8" data-id="element-245">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 relative flex flex-col" data-id="element-246">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-brand-accent/20" data-id="element-247" />
              <div className="flex gap-1 mb-4" data-id="element-248">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-brand-accent fill-brand-accent" data-id="element-249" />)}
              </div>
              <p className="text-gray-700 italic mb-6 leading-relaxed relative z-10 flex-grow" data-id="element-250">
                "{t.quote}"
              </p>
              <div className="mt-auto" data-id="element-251">
                <p className="font-bold text-brand-dark" data-id="element-252">{t.author}</p>
                <p className="text-sm text-gray-500" data-id="element-253">
                  {t.location} — {t.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}